export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-web-e9c3773085829b951ce8eff82f9954b9.svg";